import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default function BarGraph({ data, error }) {
  const categories = [];
  const categoryHours = [];

  if (data) {
    data.forEach((category) => {
      categories.push(String(`Category ${category.id}`));
      categoryHours.push(Number(category.hoursCompleted));
    });
  }

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: false,
          delay: 0,
        },
        dynamicAnimation: {
          enabled: false,
          speed: 320,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      title: {
        text: 'Hours',
        rotate: 0,
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '16px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 600,
          cssClass: 'apexcharts-xaxis-title',
        },
      },
      tooltip: {
        enabled: true,
        formatter: (val) => val,
      },
      categories,
    },

    yaxis: {
      labels: {
        show: true,
        align: 'right',
        minWidth: 0,
        maxWidth: 160,
        style: {
          colors: [],
          fontSize: '14px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 400,
          cssClass: 'apexcharts-yaxis-label',
        },
        offsetX: 0,
        offsetY: 0,
        rotate: 0,
      },
      title: {
        text: 'Categories',
        rotate: -90,
        offsetX: 10,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '16px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 600,
          cssClass: 'apexcharts-yaxis-title',
        },
      },
      tooltip: {
        enabled: false,
      },
    },

    title: {
      text: 'Category-Wise Hours',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 10,
      floating: false,
      style: {
        fontSize: '24px',
        fontWeight: 'bold',
        fontFamily: 'Arial',
        color: '#263238',
      },
    },
    tooltip: {
      x: {
        show: true,
        formatter: (val) => {
          const str = 'Min Hours: ';
          const cat = val.slice(-1);
          let num = 0;
          if (cat === '1' || cat === '2') num = 30;
          else if (cat === '3') num = 10;
          else if (cat === '4') num = 20;
          else return val;
          return str + num;
        },
      },
    },
  };

  if (error) {
    return <h3> Error loading data</h3>;
  }

  if (!data) {
    return <h3> Loading... </h3>;
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={[{ data: categoryHours, name: 'Hours' }]}
        type="bar"
        height={350 + Math.random(0, 0.1, true)}
      />
    </div>
  );
}
